import { watchEffect } from 'vue'

function getMetaSelector(definition) {
  if (definition.key) {
    return `meta[data-key="${definition.key}"]`
  }

  if (definition.name) {
    return `meta[name="${definition.name}"]`
  }

  if (definition.property) {
    return `meta[property="${definition.property}"]`
  }

  return null
}

function upsertMetaTag(definition) {
  if (!definition || !definition.content) {
    return
  }

  const selector = getMetaSelector(definition)
  if (!selector) {
    return
  }

  const existingTags = Array.from(document.head.querySelectorAll(selector))

  let tag = existingTags[0]

  if (!tag) {
    tag = document.createElement('meta')

    if (definition.key) {
      tag.setAttribute('data-key', definition.key)
    }

    if (definition.name) {
      tag.setAttribute('name', definition.name)
    }

    if (definition.property) {
      tag.setAttribute('property', definition.property)
    }

    document.head.appendChild(tag)
  }

  // Remove duplicadas
  existingTags.slice(1).forEach(t => t.remove())

  tag.setAttribute('content', definition.content)
}

function getLinkSelector(definition) {
  if (definition.key) {
    return `link[data-key="${definition.key}"]`
  }

  if (definition.rel && definition.href) {
    return `link[rel="${definition.rel}"][href="${definition.href}"]`
  }

  if (definition.rel) {
    return `link[rel="${definition.rel}"]`
  }

  return null
}

function upsertLinkTag(definition) {
  if (!definition || !definition.href || !definition.rel) {
    return
  }

  const selector = getLinkSelector(definition)
  if (!selector) {
    return
  }

  const existingTags = Array.from(document.head.querySelectorAll(selector))

  let tag = existingTags[0]

  if (!tag) {
    tag = document.createElement('link')

    if (definition.key) {
      tag.setAttribute('data-key', definition.key)
    }

    tag.setAttribute('rel', definition.rel)
    document.head.appendChild(tag)
  }

  // Remove duplicadas
  existingTags.slice(1).forEach(t => t.remove())

  Object.entries(definition).forEach(([key, value]) => {
    if (value && key !== 'key') {
      tag.setAttribute(key, value)
    }
  })
}

function applyHead(definition = {}) {
  if (definition.title) {
    document.title = definition.title
  }

  if (Array.isArray(definition.meta)) {
    definition.meta.forEach(upsertMetaTag)
  }

  if (Array.isArray(definition.link)) {
    definition.link.forEach(upsertLinkTag)
  }
}

export function createHead() {
  return {
    install() {
      // placeholder compatível
    }
  }
}

export function useHead(resolver) {
  watchEffect(() => {
    const definition = typeof resolver === 'function' ? resolver() : resolver
    applyHead(definition)
  })
}
